import { render, staticRenderFns } from "./HeadDropList.vue?vue&type=template&id=40ed0b38&scoped=true&"
import script from "./HeadDropList.vue?vue&type=script&lang=js&"
export * from "./HeadDropList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ed0b38",
  null
  
)

export default component.exports